import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import '@/router/guard'

window.addEventListener("error", e => {
    if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
        e.stopImmediatePropagation()
    }
})

const app = createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    .use(ElementPlus)

app.config.globalProperties.mainColor = process.env.VUE_APP_VUETIFY_MAIN_COLOR

app.mount('#app')